import { observer } from "mobx-react";
import * as React from "react";
import { Redirect, Route, Router } from "react-router-dom";
import { LOADING_INDICATOR_DELAY_MS } from "../../../config";
import { authStore } from "../../../stores/AuthStore";
import { generalStore } from "../../../stores/GeneralStore";
import { ApplicationRoutes } from "../../application/router/ApplicationRoutes";
import { ApplicationContainerSite } from "../../application/sites/ApplicationContainerSite";
import { AppointmentConfirmationSite } from "../../application/sites/AppointmentConfirmationSite";
import { CodeExampleSubmissionSite } from "../../application/sites/CodeExampleSubmissionSite";
import { useLocalCredentials } from "../../hooks/useLocalCredentials";
import { HrContainerSite } from "../../hr/sites/HrContainerSite";
import { ErrorSnackBar } from "../../ui/ErrorSnackbar";
import { LoadingOverlay } from "../../ui/LoadingOverlay";
import { AuthGoogleSite } from "../sites/AuthGoogleSite";
import { LoginSite } from "../sites/LoginSite";
import { CustomSwitch } from "./CustomSwitch";
import { NoAuthOnlyRoute } from "./NoAuthOnlyRoute";
import { PrivateRoute } from "./PrivateRoute";
import { Routes } from "./Routes";
import { RoutingManager } from "./RoutingManager";
import { history } from "./history";

export const AppRouter = observer(() => {
    const isLogin = useLocalCredentials();

    if (isLogin) {
        return null;
    }

    return (
        <Router history={history}>
            <RoutingManager>
                <CustomSwitch>
                    <Route exact path={Routes.ROOT}>
                        {authStore.isAuthenticated && <Redirect to={Routes.HR} />}
                        {!authStore.isAuthenticated && <Redirect to={Routes.LOGIN} />}
                    </Route>
                    <Route path={ApplicationRoutes.CODE_EXAMPLE_SUBMISSION} component={CodeExampleSubmissionSite} />
                    <Route path={ApplicationRoutes.APPOINTMENT_CONFIRMATION} component={AppointmentConfirmationSite} />
                    <Route path={Routes.GOOGLE_AUTH} component={AuthGoogleSite} />
                    <Route path={Routes.APPLICATION} component={ApplicationContainerSite} />
                    <PrivateRoute path={Routes.HR} component={HrContainerSite} />
                    <NoAuthOnlyRoute path={Routes.LOGIN} component={LoginSite} />
                </CustomSwitch>
            </RoutingManager>
            {generalStore.isLoading && <LoadingOverlay delayMs={LOADING_INDICATOR_DELAY_MS} />}
            <ErrorSnackBar />
        </Router>
    );
});
